import React from 'react'
import { Button, Form, FormGroup, Label } from "reactstrap";
import { Controller } from "react-hook-form";
import moment from 'moment';

const CustomInput = ({ fieldName, control,fieldLabel, placeholder, error, type, max, defaultValue, disabled, minimum }) => {
    return (
        <>
            <FormGroup>
                <Label
                    htmlFor="recipient-name"
                    className="col-form-label"
                >
                    {fieldLabel}
                </Label>
                <Controller
                    name={fieldName}
                    control={control}
                    render={({ field }) =>
                        <input
                            {...field}
                            aria-invalid={error ? "true" : "false"}
                            className="form-control"
                            placeholder={placeholder}
                            id="exampleInputEmail1"
                            type={type ? type : "text"}
                            maxLength={max}
                            defaultValue={defaultValue}
                            disabled={disabled}
                            max={moment().format("YYYY-MM-DD")}
                        />}
                />
                {error && <p role="alert" style={{ color: "red", display: "flex", flexDirection: "start", paddingLeft: "10px" ,fontSize:"12px"}}>{error?.message}</p>}
            </FormGroup>
        </>
    )
}

export default CustomInput